const highlight = "#ff8ca8";
const error = "#d0351a";
const yellowBackground = "#fff8d0";
const disabled = "#979797";
const nafYellow = "#ffdb00";
const black = "#000";

const Colors = {
  highlight,
  error,
  disabled,
  nafYellow,
  yellowBackground,
  black,
};

export default Colors;
